import type { StringFileResponse } from 'models/FileResponse';
import type { IBlotterPriceImprovementItem } from 'models/IBlotterItem';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { ActivityFilter, IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { IBlotterRequest, ISearchResponse } from './common';

export interface IPriceImprovementBlotterRequest extends IBlotterRequest {
  activityScope: ActivityFilter;
  endDate?: string;
  page?: number;
  size?: number;
  startDate: string;
  status?: string;
  filters?: any;
}

export type IPriceImprovementBlotterRequestTopRequest = Omit<IPriceImprovementBlotterRequest, 'sort' | 'filters'>;

export function priceImprovementBlotterApiConnector(http: IHttpClient) {
  return {
    search(request: IPriceImprovementBlotterRequest) {
      return http
        .postJSON<ISearchResponse<IBlotterPriceImprovementItem>>({
          url: 'api/v2/blotter/price-improvements',
          body: request,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchColumnDefinition(): Observable<IBlotterColumnDefinition<IBlotterPriceImprovementItem>[]> {
      return http
        .getJSON<{
          data: { columnDefinitions: IBlotterColumnDefinition<IBlotterPriceImprovementItem>[] };
          isSuccess: boolean;
        }>({
          url: 'api/v1/blotter/column-definitions/priceImprovements',
        })
        .pipe(map(({ payload }) => payload.data?.columnDefinitions ?? []));
    },
    fetchCSV(request: IPriceImprovementBlotterRequest): Observable<StringFileResponse> {
      return http
        .postRAW({
          url: 'api/v2/blotter/price-improvements/csv',
          body: request,
        })
        .pipe(
          map(response => ({
            data: response.payload,
            filename: response.attachmentName,
          })),
        );
    },
  };
}
